import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    formatErrors(errors) {
      return Object.values(errors).flat().join('<br/> ');
    },
    showError(error) {
      const errors = this.formatErrors(error.data);
      this.activeAlert({ message: errors, theme: 'danger' });
    },
  },
};
